/**
 * Platform detection.
 * Per UI-SPEC §1.4 + §9 (PA1-PA5).
 */
export type PlatformName = 'web' | 'pwa' | 'ios' | 'android' | 'telegram' | 'line' | 'discord';

export interface PlatformInfo {
  name: PlatformName;
  isStandalone: boolean;
  prefersReducedMotion: boolean;
  prefersDark: boolean;
  prefersContrast: boolean;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: unknown };
    liff?: unknown;
    DiscordSDK?: unknown;
  }
}

export function detectPlatform(): PlatformInfo {
  const ua = navigator.userAgent;
  let name: PlatformName = 'web';

  if (typeof window !== 'undefined') {
    if (window.Telegram?.WebApp) name = 'telegram';
    else if (window.liff) name = 'line';
    else if (window.DiscordSDK) name = 'discord';
    else if (
      /(iPhone|iPad|iPod)/i.test(ua) &&
      (window.navigator as { standalone?: boolean }).standalone
    )
      name = 'ios';
    else if (/Android/i.test(ua) && window.matchMedia('(display-mode: standalone)').matches)
      name = 'android';
    else if (window.matchMedia('(display-mode: standalone)').matches) name = 'pwa';
  }

  return {
    name,
    isStandalone: window.matchMedia?.('(display-mode: standalone)').matches ?? false,
    prefersReducedMotion: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false,
    prefersDark: window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false,
    prefersContrast: window.matchMedia?.('(prefers-contrast: more)').matches ?? false,
  };
}
